import React, { useEffect, useState } from "react";

import * as Styled from "./styled";

const Captions = {
  0: "Tier #1",
  1: "Tier #2",
  2: "Tier #3",
  3: "Tier #4",
  4: "Tier #5",
  5: "Premium Tier",
};

function Zone(props) {
  const [zone, setZone] = useState(props.zone);
  useEffect(() => {
    setZone(props.zone);
  }, [props.zone]);

  const [selected, setSelected] = useState(props.selected);
  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const icon = () => {
    return require(`./assets/ic-zone-${zone.id}.png`);
  };

  return (
    <Styled.Container selected={selected} onClick={() => zone.available && props.onSelect(zone)}>
      <Styled.Icon src={icon()} />
      <Styled.Name disabled={!zone.available}>{Captions[zone.id]}</Styled.Name>
    </Styled.Container>
  );
}

export default Zone;
